import { render } from "./ChurchEventBoard.vue?vue&type=template&id=9ecd9764"
import script from "./ChurchEventBoard.vue?vue&type=script&lang=js"
export * from "./ChurchEventBoard.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__